import state from '../appstatus/state'
import mutations from '../appstatus/mutations'
import actions from '../appstatus/actions'
import getters from '../appstatus/getters'

const cyclecount = {
  firestorePath: '/cyclecount',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'cyclecount',
  statePropName: 'cyclecount',
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions

  state, getters, mutations, actions
}

export default cyclecount